import React from 'react';
import map from 'lodash/map';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {List, Dropdown, Icon} from 'semantic-ui-react';
import {object, shape, arrayOf, string, func} from 'prop-types';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {Types as ResourceTypes} from 'api/resources';

const DynamicContentRuleAction = props => {
  switch (props.resourceType) {
    case ResourceTypes.ListicleItem:
      const actionOptions = map(props.actions, action => ({
        value: action,
        text: (
          <FormattedMessage
            id={`editbreak.dynamic_content_rules.actions.${action}`}
            defaultMessage={action} />
        )
      }));

      return (
        <React.Fragment>
          <Dropdown
            placeholder={<FormattedMessage id='editbreak.dynamic_content_rules.select_action' />}
            value={props.rule.action}
            options={actionOptions}
            disabled={actionOptions.length >= 1}
            onChange={props.onActionChange}
            fluid
            selection
            closeOnChange
            openOnFocus={false}
            selectOnBlur={false}
            selectOnNavigation={false} />
          <FormattedMessage id='editbreak.dynamic_content_rules.this_content' />
        </React.Fragment>
      );

    case ResourceTypes.FilteringDropdownItem:
      return <FormattedMessage id='editbreak.dynamic_content_rules.select_this_item' />;

    case ResourceTypes.ReferralLink:
      return <FormattedMessage id='editbreak.dynamic_content_rules.actions.hide' />;

    default:
      return null;
  }
};

const DynamicContentRule = props => {
  const resultOptions = map(props.results, ({resultId, stepId, title}) => ({
    value: resultId,
    text: title
  }));

  return (
    <List.Item className={classnames('dynamic-content-rule', props.className)}>
      <FormattedMessage id='editbreak.dynamic_content_rules.if' />
      <Dropdown
        placeholder={<FormattedMessage id='editbreak.dynamic_content_rules.select_result' />}
        value={props.rule.value}
        options={resultOptions}
        disabled={!resultOptions.length}
        onChange={props.onResultChange}
        fluid
        selection
        closeOnChange
        openOnFocus={false}
        selectOnBlur={false}
        selectOnNavigation={false} />
      <FormattedMessage id='editbreak.dynamic_content_rules.then' />
      <DynamicContentRuleAction {...props} />
      <Icon name='remove' onClick={props.onRemove} />
      <FieldStatusIcon
        error={props.error}
        saved={props.saved}
        isSaving={props.isSaving} />
    </List.Item>
  );
};

DynamicContentRule.propTypes = {
  resourceType: string.isRequired,
  onChange: func.isRequired,
  className: string,
  rule: shape({
    value: string,
    action: string
  }),
  results: object,
  actions: arrayOf(string)
};

DynamicContentRule.defaultProps = {
  rule: {},
  results: {},
  actions: []
};

export default DynamicContentRule;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DynamicContentRules/DynamicContentRule.jsx